import createMuiTheme from "@material-ui/core/styles/createTheme";
import { base } from "./base";
export var dark = createMuiTheme(Object.assign(Object.assign({}, base), {
    name: "dark",
    palette: Object.assign(Object.assign({}, base.palette), {
        primary: {
            light: "#064267",
            main: "#0C2E3D",
            dark: "#333333"
        }
    })
}));
